module.exports = __webpack_public_path__ + "static/img/3_1_3_1.91d00c6b.jpg";